/** @format */

import React from "react";
import { useSelector } from "react-redux";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import IntlMessages from "util/IntlMessages";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";

// ── Nav item definitions ────────────────────────────────────────────────────
const navItems = [
  {
    key: "p2p-statistics",
    to: "/p2p-statistics",
    iconClass: "icon icon-stats",
    labelId: "sidebar.p2pStatistics",
    fallback: "P2P Statistics",
  },
  {
    key: "P2PMerchant",
    to: "/P2PMerchant",
    iconClass: "icon icon-family",
    labelId: "sidebar.p2pMerchant",
    fallback: "P2P Merchants",
  },
  {
    key: "P2PTransactions",
    to: "/P2PTransactions",
    iconClass: "icon icon-shuffle",
    labelId: "sidebar.p2pTransactions",
    fallback: "P2P Transactions",
  },
  {
    key: "P2PSettings",
    to: "/P2PSettings",
    iconClass: "icon icon-setting",
    labelId: "sidebar.p2pSettings",
    fallback: "P2P Settings",
  },
];

const SidebarContent = () => {
  let { navStyle, themeType } = useSelector(({ settings }) => settings);
  let { pathname } = useSelector(({ common }) => common);

  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  const selectedKeys = pathname.substr(1);

  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <div className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}>
          <UserProfile />
          <AppsNavigation />
        </div>

        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "light" : "dark"}
            mode="inline"
          >
            {/* Section label — styled by .ant-menu-item-group-title in custom.less */}
            <Menu.ItemGroup title="P2P Portal">
              {navItems.map(({ key, to, iconClass, labelId, fallback }) => (
                <Menu.Item key={key}>
                  <Link to={to}>
                    <i className={iconClass} />
                    <span>
                      <IntlMessages id={labelId} defaultMessage={fallback} />
                    </span>
                  </Link>
                </Menu.Item>
              ))}
            </Menu.ItemGroup>
          </Menu>

        </CustomScrollbars>
      </div>
    </>
  );
};

SidebarContent.propTypes = {};

export default SidebarContent;
